document.addEventListener('DOMContentLoaded', () => {

    const topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        }
    });

    const gallerySwiper = new Swiper('.gallery-slider',{
        speed: 700,
        centeredSlides: true,
        loop:true,
        initialSlide: 1,
        breakpoints: {
            320: {
                spaceBetween: 15,
                slidesPerView: 1.2
            },
            900:{
                spaceBetween: 45,
                slidesPerView: 2
            }
        },
        navigation: {
            prevEl: '.gallery-prev',
            nextEl: '.gallery-next'
        }
    })

   const roomsOvSlider = new Swiper('.rooms-ov-swiper',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.rooms-ov-next',
            prevEl: '.rooms-ov-prev'
        }
    });

    const singleSlider = new Swiper('.single-slider_swiper',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.single-slider-next',
            prevEl: '.single-slider-prev'
        }
    });

    const sliderImgSwiper = new Swiper('.slider-img_swiper', {
        loop: true,
        speed: 700,
        slidesPerView: "auto",
        spaceBetween: 15,
        navigation: {
            nextEl: '.slider-next',
            prevEl: '.slider-prev'
        }
    });
    
    const sliderCopySwiper = new Swiper('.slider-copy_swiper', {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        allowTouchMove: false,
    });
    
    if(sliderCopySwiper) {
        sliderImgSwiper.on('slideChange', function () {
            sliderCopySwiper.slideTo(sliderImgSwiper.realIndex);
        });
    }
});